import styled from "styled-components";

export const DashboardPageContainer = styled.div`
    position: relative;
    display: flex;
    background: ${(props) => props.theme.colors.neutral[50]};

    & > div {
        margin: 2.5%;

        background: white;
        color: ${(props) => props.theme.colors.neutral[800]};
        box-shadow: 1px 0px 10px 1px rgba(231, 231, 231, 0.5);
        flex: 1;
    }

    @media (max-width: 768px) {
        & > div {
            margin: 0;
        }
    }
`;
